import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';
import { useTranslation } from 'react-i18next';

import * as S from './style';

const ErrorComponent = ({ name }) => {
  const { t } = useTranslation();
  return (
    <ErrorMessage
      name={name}
      render={(message) => <S.Error className="error">{t(message)}</S.Error>}
    />
  );
};

export default ErrorComponent;

ErrorComponent.propTypes = {
  name: PropTypes.string,
};
